import React from 'react';
import { AgFinancingMatricula } from '@indigo-ag/schema';
import { palettes } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { createStylesHook, GridContainer, GridContainerItem, parseNumberToLocale, utils } from 'shared';

interface MatriculaAnalysisSummaryProps {
  matriculaData: AgFinancingMatricula;
}

const useStyles = createStylesHook({
  card: {
    border: `1px solid ${palettes.brand.gray[300]}`,
    borderRadius: 8,
    padding: 24,
    marginBottom: 16
  }
});

export const MatriculaAnalysisSummary: React.FunctionComponent<MatriculaAnalysisSummaryProps> = ({ matriculaData }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const legalDetail = matriculaData.details?.find(m => m.id != null);

  const legalDetailItems: GridContainerItem[] = [
    {
      label: i18next.t('emissionDate'),
      value: legalDetail?.emissionDate ? utils.date.formatDate(legalDetail?.emissionDate) : undefined
    },
    {
      label: i18next.t('registrationNumber'),
      value: legalDetail?.registrationNumbers
    },
    {
      label: i18next.t('state'),
      value: legalDetail?.state?.name
    },
    {
      label: i18next.t('municipality'),
      value: legalDetail?.municipality?.name
    },
    {
      label: i18next.t('totalArea'),
      value: legalDetail?.totalArea
    },
    {
      label: i18next.t('cultivableArea'),
      value: parseNumberToLocale(legalDetail?.cultivableArea)
    },
    {
      label: i18next.t('biome'),
      value: legalDetail?.biome
    },
    {
      label: i18next.t('preservationArea'),
      value: legalDetail?.preservationArea
    },
    {
      label: i18next.t('complianceConflictArea'),
      value: legalDetail?.complianceConflictArea
    },
    {
      label: i18next.t('ibamaEmbargo'),
      value: legalDetail?.ibamaEmbargo
    },
    {
      label: i18next.t('conservationUnities'),
      value: legalDetail?.ibamaEmbargo
    },
    {
      label: i18next.t('indigenousLand'),
      value: legalDetail?.indigenousLand
    },
    {
      label: i18next.t('quilimbolasLand'),
      value: legalDetail?.quilimbolasLand
    },
    {
      label: i18next.t('ICMBIOEmbargo'),
      value: legalDetail?.ICMBIOEmbargo
    },
    {
      label: i18next.t('stateEmbargo'),
      value: legalDetail?.stateEmbargo
    },
    {
      label: i18next.t('permanentPreservationArea'),
      value: legalDetail?.permanentPreservationArea
    },
    {
      label: i18next.t('deforestationAfter2008'),
      value: legalDetail?.permanentPreservationArea
    },
    {
      label: i18next.t('legalComments'),
      value: legalDetail?.legalComments
    }
  ];

  return (
    <div className="flex flex-column">
      <div className={classes.card}>
        <GridContainer columns={2} items={legalDetailItems} />
      </div>
    </div>
  );
};
